<div class="profile">
    <div class="profile-header">
        <img [src]="profileImageUrl || 'images/members.svg'" (error)="onImageError()" #img alt="profile" />
        <div class="profile-details">
            <p class="user-name">{{ userProfile?.name }}</p>
            @if (profileAndUsername) {
                <p class="user-profile-detail">
                    @if (displayProfile) {
                        <span class="user-profile-title">{{ displayProfile }}</span>
                    }
                    @if (username) {
                        <span class="user-profile-username">{{
                            displayProfile ? ' (' + username + ')' : '(' + username + ')'
                        }}</span>
                    }
                </p>
            }
            @if (displayActiveRole) {
                <p class="user-role">{{ displayActiveRole }}</p>
            }
            @if (userProfile?.email) {
                <p class="user-email">{{ userProfile?.email }}</p>
            }
        </div>
    </div>

    <div class="profile-content">
        <div class="profile-roles">
            <mat-accordion>
                <mat-expansion-panel
                    #rolesPanel="matExpansionPanel"
                    class="mat-elevation-z0"
                    hideToggle
                    (click)="$event.stopPropagation()"
                >
                    <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
                        <mat-panel-title>
                            <img src="images/rolesLight.svg" alt="" />
                            <p>{{ 'yourRoles' | translate }}</p>
                        </mat-panel-title>
                        <img class="expansion-indicator" src="images/chevron-down.svg" alt="" />
                    </mat-expansion-panel-header>
                    <div class="profile-roles-list">
                        @for (role of userRoles; track $index) {
                            <p
                                [class.active-role]="role === activeRole"
                                role="button"
                                tabindex="0"
                                (click)="switchRole(role)"
                                (keydown.enter)="switchRole(role)"
                                (keydown.space)="switchRole(role); $event.preventDefault()"
                            >
                                {{ role.split('-').join(' ') | titlecase }}
                            </p>
                        }
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
    <div
        class="logout-section"
        role="button"
        tabindex="0"
        (click)="logout()"
        (keydown.enter)="logout()"
        (keydown.space)="logout(); $event.preventDefault()"
    >
        <img src="images/logout.svg" alt="" />
        <h1>{{ 'logout' | translate }}</h1>
    </div>
</div>
